import { Customer } from '@mews-commander/data-access';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { Avatar, SizeType } from '@optimus-web/core';

export interface GuestAvatarProps extends Pick<Customer, 'imageId'> {
    size: SizeType;
    fullName: string;
}

export const GuestAvatar = ({ fullName, imageId, size }: GuestAvatarProps) => {
    const getAvatarSrc = useGetAvatarSrc();
    return <Avatar src={getAvatarSrc(imageId)} title={fullName} size={size} />;
};
